import React, { ComponentPropsWithoutRef, FC } from 'react';
import { Field } from 'redux-form';
import { newThemeInput } from '_fields/inputs';
import { normalizeSsn, maskSsn } from '_fields/normalizers';
import { cn, Stack } from 'shared-components';
import { EyeIcon, EyeOffIcon } from 'lucide-react';

export const SsnInput: FC<{
  change: (e: any, a: string) => void;
  ownerIdx: string;
  autoFocus?: boolean;
  variant?: string;
  stackProps?: ComponentPropsWithoutRef<typeof Stack>;
  inputProps?: ComponentPropsWithoutRef<typeof newThemeInput>;
}> = ({ change, ownerIdx, autoFocus = false, variant, stackProps = {}, inputProps = {} }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleChange = (event: any) => {
    change(`owner_${ownerIdx}_ssn_masked`, maskSsn(event.target.value, true));
  };
  const handleClickShowSsn = () => setShowPassword((show) => !show);

  const handleMouseDownSsn = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <div className="relative w-full max-w-[368px]">
      <Field
        label="Social Security Number*"
        component={newThemeInput}
        {...inputProps}
        variant={variant}
        type={showPassword ? 'text' : 'password'}
        name={`owner_${ownerIdx}_ssn`}
        onChange={handleChange}
        // Hard to implement: (alters value="" on the input and feeds ***-***-** into redux)
        // format={(ssnNum: string) => maskSsn(ssnNum, showPassword)}
        normalize={normalizeSsn}
        formatAsSsn
        autoFocus={autoFocus}
      />
      <div
        aria-label="toggle ssn visibility"
        onClick={handleClickShowSsn}
        className={cn('absolute right-3 top-[12px] hover:cursor-pointer hover:opacity-80', {
          '!top-[19px]': variant === 'transparent-black',
        })}
      >
        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
      </div>
    </div>
  );
};
